import { combineReducers } from 'redux';

import autocomplete from './StatefulAutocompleteReducer';

export default combineReducers({
  autocomplete,
});
